import type { ApolloClient } from "@apollo/client"
import { cohortCustomizationResponseStatusQuery } from "../graphql/schema"

export async function checkCustomizationResponses(
  client: Pick<ApolloClient<object>, "query">,
  contextKey: string
): Promise<boolean> {
  for (let attempt = 0; attempt < 3; attempt++) {
    try {
      const { data } = await client.query({
        query: cohortCustomizationResponseStatusQuery,
        variables: { contextKey },
        fetchPolicy: "no-cache"
      })
      const hasResponses = data?.blocksContext?.customization?.hasResponses
      if (typeof hasResponses === "boolean") return hasResponses
    } catch {
      // Migration status and temporary failures need not interrupt customization.
    }
    if (attempt < 2)
      await new Promise((resolve) => setTimeout(resolve, 250 * (attempt + 1)))
  }
  // An unavailable check is not evidence of no responses. Show the warning.
  return true
}
